import { useRef, useEffect, useState } from "react";
import _ from "lodash";
import { Col, Row, Statistic } from 'antd';
import { useDataStore } from "../../../store";

//借贷平台详细数据统计
export function UsuryDetailModule (){
    const content = useDataStore( state => state.riskItems );
    const getOrderDetail = useDataStore( state => state.getOrderDetail );
    const [ data, setData ] = useState({
        //平台数
        'loanPlatformCount': 0, 
        //还款次数
        'paymentCount': 0,
        //已支付金额
        'paymentAmount': 0,
    });

    const dataKeyMap = {
        'loanPlatformCount': '借贷平台数',
        'paymentCount': '还款次数',
        'paymentAmount': '已支付金额',       
    }

    useEffect(() => {
        _.entries( content.usuryPlatform ).forEach(([ key, orders ]) => {
            orders.forEach( order => {
                const orderDetail = getOrderDetail(order);
                if( orderDetail._IE === 1 && orderDetail.AMOUNT > 0 ){
                    data.paymentAmount = _.round(data.paymentAmount + orderDetail.AMOUNT, 2);
                    data.paymentCount += 1;
                }
            });
        });
       data.loanPlatformCount = _.size( content.usuryPlatform );
       setData({...data});
    }, [ content, getOrderDetail ]);

    return <Row direction="hozizontal" gutter={[24, 24]} style={{ marginBottom: '24px' }}>
        {Object.entries(data).map(([key, value]) => {
            return <Col span={8} key={key}>
                <Statistic title={dataKeyMap[key]} value={value} />
            </Col>
        })}
    </Row>
}

